import {
   URL_GET_PRODUCTS_BRANDS,
   URL_GET_PRODUCTS_SUBCATEGORIES,
   URL_GET_SUBCATEGORIES_PRODUCTS,
   URL_GET_TOKEN_PRODUCT,
   URL_GET_PAYMENT_CODE,
   // GET_SIGNATURE,
   // GET_TOKEN,
   URL_GET_TRANSACTION_DETAIL,
   URL_GET_COIN_CONVERSION,
} from 'constants/Auth';
import { sprintf } from 'sprintf-js';
import handleError, { showErrorMessage } from './HandleError';
import { message } from 'antd';
import { restApi } from 'hooks/Interceptor';
import { getCookie } from 'cookies-next';
import { storageKeys } from 'constants/storage-keys';

export const getProductBrand = (id, params) => {
   let promiseSubCategories = new Promise((resolve, reject) => {
      restApi
         .get(sprintf(URL_GET_PRODUCTS_BRANDS, { id, params: params || '' }))
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         });
   });
   return promiseSubCategories;
};
export const getProductSubCatagories = (id, params) => {
   let promiseSubCategories = new Promise((resolve, reject) => {
      restApi
         .get(
            sprintf(URL_GET_PRODUCTS_SUBCATEGORIES, {
               id,
               params: params || '',
            }),
         )
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         })
         .catch((error) => {
            message.error(showErrorMessage(handleError(error)));
            reject();
         });
   });
   return promiseSubCategories;
};
export const getProductSubCatProduct = (id, params) => {
   let promiseSubCategories = new Promise((resolve, reject) => {
      restApi
         .get(
            sprintf(URL_GET_SUBCATEGORIES_PRODUCTS, {
               id,
               params: params || '',
            }),
         )
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         });
   });
   return promiseSubCategories;
};

export const getTokenProduct = (product, body, supplier = 'rajabiller') => {
   let promiseGetToken = new Promise((resolve, reject) => {
      restApi
         .post(
            sprintf(URL_GET_TOKEN_PRODUCT, {
               supplier: supplier.toLowerCase(),
               product: product,
            }),
            body,
            // {
            //    headers: { Signature: GET_SIGNATURE },
            // },
         )
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         })
         .catch((error) => {
            message.error(showErrorMessage(handleError(error)));
            reject();
         });
   });
   return promiseGetToken;
};
export const getDataCheckout = (
   product,
   token = '',
   supplier = 'rajabiller',
   // pin,
) => {
   let promiseGetCheckout = new Promise((resolve, reject) => {
      restApi
         .post(
            sprintf(URL_GET_PAYMENT_CODE, {
               supplier: supplier.toLowerCase(),
               product: product,
            }),
            {
               // pin: pin, // Get `product_id` references from product hierarchy
               token: token, // Should be encryption
               payment: 'POINT',
            },
            // {
            //    headers: { Signature: GET_SIGNATURE },
            // },
         )
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         })
         .catch((error) => {
            message.error(showErrorMessage(handleError(error)));
            reject();
         });
   });
   return promiseGetCheckout;
};
export const getDataCheckoutPulsa = (
   product,
   product_id,
   phone = '',
   supplier = 'rajabiller',
   token = '',
) => {
   var body = {
      product_id: product_id,
      phone: phone, // Should be encryption
      payment: 'POINT',
   };
   if (supplier === 'Ayoconnect') {
      body = { ...body, token: token };
   }
   let promiseGetCheckout = new Promise((resolve, reject) => {
      restApi
         .post(
            sprintf(URL_GET_PAYMENT_CODE, {
               supplier: supplier.toLowerCase(),
               product: product,
            }),
            body,
            // {
            //    headers: { Signature: GET_SIGNATURE },
            // },
         )
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         })
         .catch((error) => {
            message.error(showErrorMessage(handleError(error)));
            reject();
         });
   });
   return promiseGetCheckout;
};

export const getOrderEwallet = (product_id, phone = '', supplier, product) => {
   const access_token = getCookie(storageKeys.ACCESS_KEY_OUTLET);
   let promiseGetCheckout = new Promise((resolve, reject) => {
      restApi
         .post(
            sprintf(URL_GET_PAYMENT_CODE, {
               supplier: supplier.toLowerCase(),
               product: product,
            }),
            {
               product_id: product_id,
               phone: phone, // Should be encryption
               payment: 'POINT',
            },
            {
               headers: { 'X-AUTH-TOKEN': access_token },
            },
         )
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         })
         .catch((error) => {
            message.error(showErrorMessage(handleError(error)));
            reject();
         });
   });
   return promiseGetCheckout;
};
export const getCheckoutProductKonveksi = (product_id) => {
   let promiseGetCheckout = new Promise((resolve, reject) => {
      restApi
         .post(sprintf(URL_GET_COIN_CONVERSION), {
            product_id: product_id,
         })
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         })
         .catch((error) => {
            message.error(showErrorMessage(handleError(error)));
            reject();
         });
   });
   return promiseGetCheckout;
};
export const getDetailTransaction = (id) => {
   let promiseGetCheckout = new Promise((resolve, reject) => {
      restApi
         .get(
            sprintf(URL_GET_TRANSACTION_DETAIL, {
               id,
            }),
            // {
            //    headers: { 'X-AUTH-TOKEN': GET_TOKEN },
            // },
         )
         .then((response) => {
            const { data } = response.data;
            resolve(data);
         })
         .catch((error) => {
            message.error(showErrorMessage(handleError(error)));
            reject(true);
         });
   });
   return promiseGetCheckout;
};
